/* Responsibility: Set up input field focus event to open a calendar widget */
/* global Kalendae */
const format = 'DD.MM.YYYY';

function checkSelectedDate(options) {
    if (options.selectedDate) {
        options.selectedDate = moment(options.selectedDate, format).isBefore(moment(), 'day') ? '' : options.selectedDate;
    }
}

export default function (input, options) {
    checkSelectedDate(options);
    const calendar = new Kalendae.Input(input, {
        selected: options.selectedDate,
        weekStart: 1,
        direction: 'today-future',
        dayOutOfMonthClickable: true,
        useYearNav: false,
        months: options.months || 2,
        format,
        blackout: options.blackout,
        closeButton: false,
        viewStartDate: options.viewStartDate,
    });

    calendar.subscribe('date-clicked', () => {
        input.blur();
        calendar.hide();
        if (options.focus && document.getElementById(options.focus)) {
            document.getElementById(options.focus).focus();
        }
    });

    return calendar;
}
